export default "__VITE_ASSET__b074a93a__"